import { ProspectConstants } from 'constants/prospect';
import { createAction } from 'redux-actions';

export const importProspectApplications = createAction(ProspectConstants.PROSPECT_IMPORT_APPLICATIONS);
export const importProspectApplicationsId = createAction(ProspectConstants.PROSPECT_IMPORT_APPLICATION_ID);



// WEBPACK FOOTER //
// ./src/actions/prospect.js